import { FileInput } from '@repo/ui-web';

export function FileInputShowcase() {
  return (
    <div className="max-w-sm">
      <FileInput aria-label="Upload file" />
    </div>
  );
}
